import React, { useState, useEffect } from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { Icon, Button, DropdownMenu, Chip } from '@arnsbogroup/react-voicearchive'
import useApi from 'hooks/useApi'
import classNames from 'classnames'

export default ({ order, version, refetch, buttonProps = {} }) => {
  const { formatMessage } = useIntl()
  const history = useHistory()
  const [loading, setLoading] = useState(false)

  const [types,,, loadTypes] = useApi(`/rest/v2/ordertasktype?pageSize=10000`, { load: false })

  const onSubmit = (typeId) => {
    setLoading(true)

    const body = new FormData()
    body.append('orderid', order.uid)
    body.append('parentid', version.uid)
    body.append('typeId', typeId)

    fetch(`/ordertask/createdefaulttask.json`, { method: 'POST', body })
      .then((response) => response.json())
      .then(({ taskid }) => history.push(`/orders/${order.uid}/jobs/${version.parenttask}/versions/${version.uid}/tasks/${taskid}`))
      .then(() => setLoading(false))
      .then(refetch)
      .catch((error) => toastr.error(error))
  }

  return (
    <DropdownMenu
      button={{
        variant: 'inline',
        disabled: loading,
        className: "opacity-0 group-hover:opacity-100",
        children: loading ? 'Creating..' : '+ Task',
        onClick: loadTypes,
        ...buttonProps,
      }}
      items={!types ? [{ children: 'Loading...' }] : types.map(({ uid, name }) => ({
        children: `+ ${name}`,
        onClick: () => onSubmit(uid),
      })) || []}
    />
  )
}
